import { useQueryFilters } from '@cannect/hooks/utils/useQueryFilters'
import { useGetProductSubcategories } from '@cannect/services/resources/products'
import { useCallback, useMemo } from 'react'
import { DEFAULT_SUBCATEGORY_IMAGE, SUBCATEGORY_IMAGE_MAP } from './constants'
import { ISubcategoryCircle } from './types'

export const useSubcategoryCircles = () => {
  const { queryParams, updateQueryParams } = useQueryFilters<{ shopify_collection: string }>()
  const { data, isLoading, isError } = useGetProductSubcategories()

  const subcategories: ISubcategoryCircle[] = useMemo(
    () =>
      (data?.subcategories || []).map((subcategory) => ({
        ...subcategory,
        image: SUBCATEGORY_IMAGE_MAP[subcategory.handle] || DEFAULT_SUBCATEGORY_IMAGE
      })),
    [data]
  )

  const isSelectedSubcategory = useCallback(
    (subcategory: ISubcategoryCircle) => queryParams.get('shopify_collection') === subcategory.handle,
    [queryParams]
  )

  const handleSubcategoryClick = useCallback(
    (subcategory: ISubcategoryCircle) => {
      updateQueryParams({ shopify_collection: subcategory.handle })
    },
    [updateQueryParams]
  )

  return {
    subcategories,
    isLoading,
    hasSubcategories: !isError && subcategories.length > 0,
    isSelectedSubcategory,
    handleSubcategoryClick
  }
}
